export default __webpack_public_path__ + "e34605bc0c1785525c9a6eece2469218.svg";